import { CompanyAffiliateResponse } from '@ninety/platform/models/company/company-affiliate-response';
import { DomainPartnerConfiguration } from '@ninety/platform/models/login/login-domain-partner-configurations';

export interface AnonymousStateModel {
  affiliatePartnerCompany: CompanyAffiliateResponse;
  partnerConfiguration: DomainPartnerConfiguration;
}

export const initialAnonymousState: AnonymousStateModel = {
  affiliatePartnerCompany: null,
  partnerConfiguration: null,
};
